export function isNetworkFetchError(error: unknown): boolean {
  if (!(error instanceof TypeError)) return false;

  const message = error.message.toLowerCase();
  return (
    message.startsWith('failed to fetch')
    || message === 'load failed'
    || message.includes('networkerror when attempting to fetch resource')
  );
}
